<template>
  <div>
    <!-- Filters -->
    <b-row>
      <b-col cols="12">
        <okr-overview-filters
          ref="filters"
          :search="search"
          :year="parseInt(year)"
          :quarter="parseInt(quarter)"
          :structure-type="structureType"
          :loadingSearch="loading"
        />
        <okr-overview-totalizer
          :consultants-count="totalItems"
          :loading="loadingTotalizer" 
        />
        <div v-if="loading" class="d-flex justify-content-center my-2">
          <b-spinner variant="primary" />
        </div>
        <div v-else>
          <div class="mb-2 mt-0">
            <!-- Table Top --->
            <okr-overview-card
              v-for="item in items"
              :key="item.id"
              :consultant-name="item.name"
              :consultant-role="item.role.name"
              :consultant-id="item.id"
              :consultant-img="item.picture_file_url"
              :consultant-contract-type="item.contract_type? item.contract_type.name:''"
              :quarter="parseInt(selectedQuarter)"
              :year="parseInt(selectedYear)"
              :okr-total="parseFloat(item.okr_total || 0)"
              :prolabore-amount="parseFloat(item.prolabore_total)"
              :prolabore-meta="parseFloat(item.prolabore_meta)"
              :leads-quantity="parseInt(item.leads_qtd)"
              :hot-leads-quantity="parseInt(item.hotleads_qtd)"
              :ea-quantity="parseInt(item.ea_qtd)"
              :ef-quantity="parseInt(item.ef_qtd)"
              :ep-quantity="parseInt(item.ep_qtd)"
              :progress="parseFloat(item.progress_percentage)"
              :search="search"
            />
          </div>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >Exibindo {{ pageItemsFrom }} a {{ pageItemsTo }} de
                  {{ totalItems }} itens</span
                >
              </b-col>
              <!-- Pagination --->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="itemsPerPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="search"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  BSpinner,
  BFormGroup
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";
import useAppConfig from "@core/app-config/useAppConfig";
import OkrOverviewFilters from "../components/OkrOverviewFilters.vue";
import OkrOverviewTotalizer from "../components/OkrOverviewTotalizer.vue";
import OkrOverviewCard from "../components/OkrOverviewCard.vue";
import * as structureTypes from "@/constants/structure_options";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormGroup,
    vSelect,
    OkrOverviewFilters,
    OkrOverviewTotalizer,
    OkrOverviewCard
  },
  setup() {
    const { skin } = useAppConfig();

    return { toast: useToast(), skin };
  },
  data() {
    return {
      structureTypes,
      loading: false,
      loadingTotalizer: false,
      currentPage: 1,
      itemsPerPage: 10,
      selectedYear: this.year,
      selectedQuarter: this.quarter
    };
  },
  props: {
    quarter: {
      type: Number,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    structureType: {
      type: String,
      required: false,
      default: structureTypes.STRUCTURE,
    },
  },
  watch: {
    structureType(){
      this.search(1);
    }
  },
  computed: {
    ...mapGetters({
      searchResult: types.OKR_OVERVIEW_LIST
    }),
    items: function () {
      return this.searchResult?.data || [];
    },
    totalItems: function () {
      return this.searchResult?.total || 0;
    },
    pageItemsFrom: function () {
      return this.searchResult?.from || 0;
    },
    pageItemsTo: function () {
      return this.searchResult?.to || 0;
    },
  },
  methods: {
    ...mapActions({
      searchOkr: types.SEARCH_OKR_OVERVIEW_LIST,
      getOkrOverviewTotalizer: types.GET_OKR_OVERVIEW_TOTALIZER
    }),
    search(currentPage) {
      const {
        franchise,
        selectedYear,
        selectedQuarter,
        consultant,
        itemsPerPage
      } = this.$refs.filters;
      this.itemsPerPage = itemsPerPage;
      this.selectedYear = parseInt(selectedYear);
      this.selectedQuarter = parseInt(selectedQuarter);
      this.loading = true;
      this.currentPage = Number.isInteger(currentPage)
        ? currentPage : 1;
      this.searchOkr({
        structure_type: this.structureType,
        year: this.selectedYear,
        quarter: this.selectedQuarter,
        digital_franchises: franchise,
        consultants: consultant,
        currentPage: this.currentPage,
        limit: this.itemsPerPage
      })
        .catch(error => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              text: error?.response?.data?.message || 
                'Ocorreu um erro ao carregar a lista de OKR. Entre em contato com o setor de TI.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loading = false;
        });
      this.loadingTotalizer = true;
      this.getOkrOverviewTotalizer({
        structure_type: this.structureType,
        year: this.selectedYear,
        quarter: this.selectedQuarter,
        digital_franchises: franchise,
        consultant
      })
        .catch(error => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              text: error?.response?.data?.message || 
                'Ocorreu um erro ao carregar o totalizador do OKR. Entre em contato com o setor de TI.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loadingTotalizer = false
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
